import React, { useEffect, useRef } from 'react';
import {connect} from "react-redux";
import {Layout} from "antd";
import PublicHeader from "../Public/PublicHeader";
import {Route,withRouter,Switch} from "react-router-dom";
import {Loading} from "../Loading/Loading";
import Notification from "../Notification/Notification";
import Modal from "../Modal/Modal";
import {
    ADV_FILES_ROUTE,
    ADV_ID_ROUTE,
    ADV_LOGIN_ROUTE, ADV_ORDERS_ROUTE, ADV_TEMPLATES_ROUTE,
    CODES_ROUTE,
    CONFIRMATION_ROUTE,
    DOCUMENT_ROUTE,
    LOGIN_ROUTE, NEW_PASSWORD_ROUTE,
    PHOTO_ROUTE,
    VALIDATE_ROUTE
} from "./routes";
import ValidateID from "../ValidateID/ValidateID";
import Document from "../Document/Document";
import Photo from "../Photo/Photo";
import Confirmation from "../Confirmation/Confirmation";
import Codes from "../Codes/Codes";
import Login from "../Login/Login";
import AdvisorLogin from "../AdvisorLogin/AdvisorLogin";
import AdvisorID from "../AdvisorID/AdvisorID";
import Orders from "../Orders/Orders";
import Templates from "../Templates/Templates";
import PrivateSider from "../PrivateSider";
import WorkflowDocs from "../WorkflowDocs";
import NewPassword from "../NewPassword/NewPassword";
import isLoggedIn from '../../actions/isLoggedIn';
import { getCustomColors } from '../../Helpers/utils';

const AppContainer = (props) => {
    const localProps = useRef(props);
    const customization = props.customization;
    useEffect(() => {
        localProps.current.isLoggedIn({customization:true});
        customizationCSS(getCustomColors())
    },[]);
    useEffect(() => {
        const storageCustomization = window.localStorage.getItem('customization');
        const strCustomization = customization ? JSON.stringify(customization) : ''
        if (strCustomization !== '{}' && strCustomization !== 'null') {
            if (!strCustomization && storageCustomization)
                window.localStorage.removeItem('customization')
            else if (strCustomization !== storageCustomization)
                window.localStorage.setItem('customization', strCustomization)
            customizationCSS(getCustomColors(customization))
        }
    }, [customization]);

    const customizationCSS = (jsonColors) => {
        Object.keys(jsonColors).map(color => document.documentElement.style.setProperty(`--${color}`, jsonColors[color]));
    }


    return (
        <Layout className={'h-100 w-100'}>
            <Modal/>
            <Loading language={props.language}/>
                <Notification/>
                <PublicHeader/>
                <PrivateSider/>
                <Layout.Content>
                    <div className={'h-100'}>
                        <Switch>
                            <Route path='/' exact component={ValidateID}/>
                            <Route path={VALIDATE_ROUTE} exact component={ValidateID}/>
                            <Route path={DOCUMENT_ROUTE} exact component={Document}/>
                            <Route path={PHOTO_ROUTE} exact component={Photo}/>
                            <Route path={CONFIRMATION_ROUTE} exact component={Confirmation}/>
                            <Route path={CODES_ROUTE} exact component={Codes}/>
                            <Route path={LOGIN_ROUTE} exact component={Login}/>
                            <Route path={ADV_LOGIN_ROUTE} exact component={AdvisorLogin}/>
                            <Route path={ADV_ID_ROUTE} exact component={AdvisorID}/>
                            <Route path={ADV_ORDERS_ROUTE} exact component={Orders}/>
                            <Route path={ADV_TEMPLATES_ROUTE} exact component={Templates}/>
                            <Route path={ADV_FILES_ROUTE} exact component={WorkflowDocs}/>
                            <Route path={NEW_PASSWORD_ROUTE} exact component={NewPassword}/>
                        </Switch>
                    </div>
                </Layout.Content>
        </Layout>
    );

};


function mapStateToProps(state) {
    return {
        language:state.auth.language,
        customization: state.info.customization
    }
}

export default withRouter(connect(mapStateToProps, {isLoggedIn})(AppContainer));